import React, { useState, useEffect, useMemo, useRef } from 'react'
import Axios from 'axios';
import NotData from '../../components/NotData';
import itemTypeList from '../../common/itemTypeList';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { Toast } from '../../common/message';
import NumberPad from '../../components/NumberPad';
import UserPointExp from '../../common/UserPointExp';
import MainButton from '../../components/MainButton';

function Sale() {
  Axios.defaults.withCredentials = true; // 세션을 관리하고자하는 파일에 꼭 작성

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }

  // 숫자 천자리 콤마
  function NumberConvert(num) {
    let num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
  }
    
  const firstCursor = useRef(null);
  const [books, setBooks] = useState([]);
  const columns = [
    'No', '브랜드', '분류', '제품이름', '가격', '탄방', '둔산', '자양', '충대'
  ];

  const [Selected, setSelected] = useState('');
  
  const [itemIno, setItemIno] = useState(0);

  const [ItemBrand, setBrand] = useState('');
  const [ItemType, setItemType] = useState('');
  const [ItemName, setItemName] = useState('');
  const [ItemPrice, setItemPrice] = useState(0);
  const [itemCount, setItemCount] = useState(0);
  const [itemTotalPrice, setItemTotalPrice] = useState(0);
  // const [itemDiscountPrice, setItemDiscountPrice] = useState(0);

  const [saleCard, setSaleCard] = useState(false);
  const [saleCash, setSaleCash] = useState(false);
  const [saleTransfer, setSaleTransfer] = useState(false);
  const [saleType, setSaleType] = useState('');
  const [saleMemo, setSaleMemo] = useState('');

  const [search, setSearch] = useState('');

  const basicID = window.sessionStorage.getItem('basicID');
  const basicName = window.sessionStorage.getItem('basicName');
  const basicPosition = window.sessionStorage.getItem('basicPosition');
  const basicStore = window.sessionStorage.getItem('basicStore');

  const userId = `${basicID ?? '🐛새로고침 해주세요'}(${basicPosition ?? '오류'})`;
  const [userStore, setUserStore] = useState('');

  const [showNumberPad, setShowNumberPad] = useState(false);
  const [numberPadValue, setNumberPadValue] = useState(0);

  const [itemIdx, setItemIdx] = useState(0);

  // 수정된 값으로 교체
  const copyStateUpdate = (count)=>{
    setBooks(()=>{
      const copy = [...books]
      switch(basicStore){
        case '탄방점' : copy[itemIdx].i_count_TB -= count; break;
        case '둔산점' : copy[itemIdx].i_count_DS -= count; break;
        case '자양점' : copy[itemIdx].i_count_JY -= count; break;
        case '충대점' : copy[itemIdx].i_count_CD -= count; break;
        default : break;
      }      
      return copy;
    });
  }

  useEffect(()=>{
    document.title = '제품판매';

    firstCursor.current.focus();
    
    setUserStore(basicStore);
  }, []);

  // 검색 버튼 부분
  const btnClick = (e)=>{

    e.preventDefault();

    setSearchPopup(false);
    setSearchItemNo(-1);

    if(!search) return alert('검색어를 입력해 주세요');

    if(search && Selected === '전체') {
      return itemNameLoade(); // 제품명만 조회
    }

    if(search && Selected !== '전체'){
      return itemTypeNameSearch(); // 분류와 제품명 동시 조회
    } 

    if(!search && Selected === '전체') {
      return handleSelect(Selected); // 분류만 조회
    } 
    
  };

   // 분류 + 제품명 검색
  const itemTypeNameSearch = async (value)=>{
    await Axios.get('/api/sale/sale_typename', {
      params: { searchText: search, Type: value ?? Selected }
    })
    .then((res)=>{
      if(res.data.length)
      {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    });
    setSelectedRow(-1);
  };
  
  // 분류 탭 부분
  const handleSelect = (e) => {

    firstCursor.current.focus();
    
    setSearchPopup(false);
    setSearchItemNo(-1);

    if(search){
      itemTypeNameSearch(e.target.value);
    } else {
      itemTypeLoade(e.target.value);
    }
  };

  // 아이템 타입 조회
  const itemTypeLoade = async (value) => {
    await Axios.get(`/api/sale/type`, {
      params: { Type: value }
    })
    .then((res)=>{
      if(res.data.length)
      {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    });
    setSelectedRow(-1);
  };
  
  // 아이템 검색 함수
  const itemNameLoade = async () => {
    await Axios.get(`/api/sale/name`, { params: { Search: search } })
    .then((res)=>{
      if(res.data.length)
      {
        setBooks(res.data);        
      } else {
        setBooks([]);
      }
    });    
  };

  // 검색창 아이템 검색 함수
  const searchItemNameLoade = async (value) => {
    await Axios.get(`/api/sale/searchname`, { params: { Search: value } })
    .then((res)=>{
      if(res.data.length)
      {
        setBooks(res.data);        
      } else {
        setBooks([]);
      }
    });    
  };

  // 수량 업 다운
  const ItemCount_Down5 = ()=>{
    if(itemCount <= 0 || itemCount < 5) return;
    setItemCount(itemCount - 5);
  }
  const ItemCount_Down = ()=>{
    if(itemCount <= 0) return;
    setItemCount(itemCount - 1);
  }
  const ItemCount_Up = ()=>{
    setItemCount(itemCount + 1);
  }
  const ItemCount_Up5 = ()=>{
    setItemCount(itemCount + 5);
  }

  // 아이템 카운트 체크
  useEffect(()=>{
    setItemTotalPrice(ItemPrice * itemCount);
  }, [ItemPrice, itemCount])
  
  const Reset = ()=>{ // 초기화 부분
    setItemIno(0);
    // setSelected('');
    setBrand('');
    setItemType('');
    setItemName('');
    setItemPrice(0);
    setItemCount(0);
    setItemTotalPrice(0);
    // setItemDiscountPrice(0);
    // setSearch('');
    setSaleCard(false);
    setSaleCash(false);
    setSaleTransfer(false);
    setSaleType('');
    setSaleMemo('');
    setShowNumberPad(false);

    setSelectedRow(-1);

    setNumberPadValue(0);
  }
  
  // 아이템 판매, 서비스, 시연용 처리시 재고 차감
  const ItemSaleUpdate = async ()=>{
    await Axios.put(`/api/sale/saleupdate`, {
      store: window.sessionStorage.getItem('basicStore'),
      itemIno: itemIno, itemCount: itemCount
    })
    .then((res)=>{
      // 불러온 데이터 카피본으로 수정
      copyStateUpdate(itemCount);
    })
  }
    
  // 아이템 판매 처리
  const ItemSale = async (e) => {
    e.preventDefault();

    if(!ItemName) return Toast.fire({ icon: "warning", text: `제품을 선택해 주세요` });
    if(itemCount === 0) return Toast.fire({ icon: "warning", text: `수량을 확인해 주세요` });
    if(!saleCard && !saleCash && !saleTransfer){
      return Toast.fire({ icon: "warning", text: `결제 방식을 선택해 주세요` });
    }
    if(!window.confirm('제품을 판매하시겠습니까?')) return;
    
    await Axios.post(`/api/sale/sale/`, {
      itemIno, Store: basicStore, State: '정상', ItemBrand, ItemType, ItemName, ItemPrice, itemCount, numberPadValue: numberPadValue ?? 0,
      itemTotalPrice, saleCard, saleCash, saleTransfer, saleMemo, saleID: basicID, saleDate: toDay.time
    })
    .then((res)=>{
      ItemSaleUpdate();
      Reset();      
      Toast.fire({ icon: "success", text: `${ItemName} ${itemCount}개 판매 완료` });
      // 포인트 및 기여도 지급
      UserPointExp('제품판매', `${ItemName} 판매`, 1, 1);
    });    
  };

  // 아이템 서비스 처리
  const ItemService = async (e) => {
    e.preventDefault();

    if(!ItemName) return Toast.fire({ icon: "warning", text: `제품을 선택해 주세요` });
    if(itemCount === 0) return Toast.fire({ icon: "warning", text: `수량을 확인해 주세요` });
    if(!window.confirm('제품을 서비스 처리하시겠습니까?')) return;

    await Axios.post(`/api/sale/service/`, {
      itemIno, ItemBrand, ItemType, ItemName: ItemName, ItemPrice, itemCount,
      numberPadValue: 0, itemTotalPrice: 0, saleMemo, saleID: basicID,
      Store: basicStore, saleDate: toDay.time
    })
    .then((res)=>{
      ItemSaleUpdate();      
      Reset();
      Toast.fire({ icon: "success", text: `${ItemName} ${itemCount}개 서비스 성공` });
      // 포인트 및 기여도 지급
      UserPointExp('제품판매', `${ItemName} 서비스`, 1, 1);
    })
    .catch((err)=>{
      console.log(err);
    });
  }

  // 아이템 시연용 처리
  const ItemTesting = async (e) => {
    e.preventDefault();

    if(!ItemName) return Toast.fire({ icon: "warning", text: `제품을 선택해 주세요` });
    if(itemCount === 0) return Toast.fire({ icon: "warning", text: `수량을 확인해 주세요` });
    if(!window.confirm('제품을 시연용 처리하시겠습니까?')) return;
    
    await Axios.post(`/api/sale/testing/`, {
      itemIno, ItemBrand, ItemType, ItemName: ItemName, ItemPrice, itemCount,
      numberPadValue: 0, itemTotalPrice: 0, saleMemo, saleID: basicID, 
      Store: basicStore, saleDate: toDay.time
    })
    .then((res)=>{
      ItemSaleUpdate();      
      Reset();
      Toast.fire({ icon: "success", text: `${ItemName} ${itemCount}개 시연용 성공` });
      // 포인트 및 기여도 지급
      UserPointExp('제품판매', `${ItemName} 시연용`, 1, 1);
    })
    .catch((err)=>{
      console.log(err);
    });
  };

  // 셀렉트 테스트
  const [selectedRow, setSelectedRow] = useState(-1);

  // 검색창 데이터 테스트
  const [searchItemNo, setSearchItemNo] = useState(-1); // 항목 선택시 고유 번호
  const [searchPopup, setSearchPopup] = useState(false);
  const [searchItemList, setSearchItemList] = useState([]);
  
  // 아이템 이름 불러오기
  useMemo(()=>{
    let Mount = true;
    // 미리 아이템 이름을 배열에 저장
    const SearchItemList = async ()=>{
      await Axios.get('/api/sale/itemlist', { params: { Store: basicStore }})
      .then((res)=>{
        if(Mount){
          setSearchItemList(res.data);
        } else {
          setSearchPopup(false);
          setSearchItemList([]);
        }
      })
    };
    SearchItemList();
    return ()=>{
      Mount = false;
    }
  }, [])

  // 검색창 부분
  const changeArr = [];
  const searchArr = ()=>{
    
    if(changeArr.length === 0)
    {
      return (
        searchItemList.map((item, idx)=>(
          changeArr.push(item.i_name)
        ))
      )
    }

    // 자동완성 필터링
    const matchDataList = search.trim() ? changeArr.filter(label => label.includes(search.trim())) : [];
    
    return matchDataList;
  }

  // 검색창 키 다운 이벤트
  const searchKeyDown = (e)=>{
    if(searchPopup){
      switch (e.keyCode) {
        // UP KEY
        case 38:
          // nowIndex = Math.max(nowIndex - 1, 0);
          setSearchItemNo((prev)=> prev === 0 ? 0 : prev - 1);
          console.log('키 업');
          break;
    
        // DOWN KEY
        case 40:
          // nowIndex = Math.min(nowIndex + 1, matchDataList.length - 1);
          console.log('키 다운', searchArr().length);
          setSearchItemNo((prev)=> prev === searchArr().length ? 0 : prev + 1);
          break;
    
        // ENTER KEY
        case 13:
          // document.querySelector("#search").value = matchDataList[nowIndex] || "";
          // 초기화
          // nowIndex = 0;
          // matchDataList.length = 0;
          console.log('엔터키');
          break;
    
        // 그외 다시 초기화
        default:
          // nowIndex = 0;
          console.log('초기화');
          break;
      }
    }
  }
  
  return (

  // 메인 틀
  <div className='p-3 md:h-[calc(100vh-4rem)] text-sm'>

    {/* 헤더 부분 */}
    <nav className='flex justify-between md:ml-1'>
      <form className='md:flex md:flex-row flex-col lg:justify-start justify-center  items-center gap-1 w-full md:w-3/4' autoComplete='off'>
        <Link to='/sale' style={{ fontFamily: 'Nosifer, cursive'}} className=
        'hidden lg:relative lg:min-w-[305px] p-3 cursor-pointer lg:inline text-3xl text-yellow-400 mx-5'>
          <p className='active:scale-y-[-1] hover:scale-95 duration-100'>
            VapeMarket
          </p>
        </Link>
        <select className='transition bg-[#1E1E1E] hover:opacity-80 h-[40px] my-2 md:my-0 p-2 px-2 w-full md:w-32 rounded-sm cursor-pointer text-sm outline-none border-[1px] border-[#6E6E6E]'
        value={Selected} onChange={(e)=>{
          setSelected(e.target.value);
          handleSelect(e);          
        }}>
        {itemTypeList.map((item) => (
          <option value={item} key={item}>
            {item}
          </option>
        ))}
        </select>

        {/* 상단 검색창 */}
        <div className='md:flex grid grid-cols-1 gap-1 relative'>

          {/* 검색창 */}
          <input className=
          'transition bg-[#1E1E1E] focus:bg-[#1E1E1E]/30 hover:opacity-80  md:w-60 w-full h-[40px] p-2 rounded-sm text-center text-sm outline-none border-[1px] border-[#6E6E6E]' 
            type='search' placeholder='브랜드 or 이름' value={search} ref={firstCursor}
            onChange={(e)=>{
              setSearch(e.target.value);
              setSearchItemNo(-1);
              setSearchPopup(true);              
            }}
            onDoubleClick={()=>setSearch(window.sessionStorage.getItem('select_copy'))}/>
          {/* 검색 버튼 */}
          <input className=
          'transition bg-[#1E1E1E]/80 focus:bg-[#1E1E1E]/30 border-yellow-400 border-[1px] hover:opacity-80 active:opacity-50 md:w-20 w-full h-[40px] my-2 md:my-0 px-3 py-2 rounded-sm cursor-pointer'
          type='submit' value='검색' onClick={ btnClick }/>

          {
            searchPopup && searchArr().length &&
            <>
              <div className={`${searchArr().length ? 'inline' : 'hidden'} z-20 absolute mt-12 w-full duration-150 flex flex-col justify-center items-center`}>
                {
                <div className={`bg-[#3E3E3E]/90 hover:bg-[#2E2E2E] border-[1px] border-gray-500 duration-150 shadow-lg shadow-[#1E1E1E] max-h-[270px] overflow-y-auto p-3 w-full rounded-sm flex flex-col gap-1`}>
                {searchArr().map((item, idx)=>(
                  <div key={idx} className={`
                  active:${searchItemNo !== idx && 'bg-[#1E1E1E]/80'} active:opacity-[0.9] tracking-wide active:scale-[0.98] focus:scale-[0.98] px-2 py-1 duration-150 rounded-md cursor-pointer
                  ${searchItemNo === idx ? 'bg-red-500' : 'hover:bg-blue-500/90'}`} 
                  onClick={()=>{
                    setSearchItemNo(idx);
                    setSearch(item);
                    setSearchPopup(false);

                    setSelected('전체');
                    searchItemNameLoade(item);
                  }}>
                    <div className='flex justify-between tracking-wides'>
                      <p className=''>{item}</p>
                    </div>
                  </div>
                ))}
                </div>
                }

                {/* <div className='text-xs flex gap-3 whitespace-nowrap justify-center items-center bg- w-full mt-3 px-3 py-1 rounded-2xl'>
                  <p className='bg-red-500 py-1 px-2 rounded-3xl'>검토중</p>
                  <p>해당 기능은 적용되거나 제거 될 수 있습니다</p>
                </div> */}

              </div>              
            </>
          }

        </div>
      </form>
      <div className='hidden shadow-gray-500 shadow-inner bg-[#424242] relative mb-1 w-1/4 py-4 md:flex flex-col items-center justify-between border-[#FFD600] border-[1px] rounded-t-md'>
        <p className='text-lg py-1' style={{ fontFamily: 'Gugi, cursive'}}>{userId}</p>
        <progress className='my-Progress-01 hover:cursor-help absolute bottom-0 w-full h-1.5 hover:h-3 hover:duration-150 hover:delay-75' value='20' max='100'></progress>
      </div>
    </nav>

    {/* 섹션 부분 */}
    <section className='grid grid-cols-1 h-[calc(100%-4.6rem)] md:grid-cols-2 md:flex justify-between md:gap-1 gap-2'>
    
      {/* 메인 */}
      <div className='relative border-[1px] md:h-full h-[50vh] border-gray-500 w-full md:w-3/4 overflow-y-auto'>
        <table id='testTable' className='w-full'>
          <thead className='bg-[#1E1E1E]/90 text-center whitespace-nowrap sticky top-0 z-10'>
            <tr className="border-b-[1px] border-gray-500">
              {columns.map((column) => (
                <th className='p-3' key={column}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody className='text-center'>
            {
              books.length ?
              books.map((book, idx) => (
                <tr key={idx} className=
                  {`
                    duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                    ${selectedRow === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
                  `}
                  onClick={(e)=>{
                  
                  // 셀렉트 테스트
                  setSelectedRow(idx);

                  setItemIdx(idx);
                  setItemIno(book.no);
                  setBrand(book.i_brand);
                  setItemType(book.i_type);

                  setItemCount(1);
                  // setItemDiscountPrice(0);
                  
                  // const nameConvert = name.replace("&amp;", "&"); // & 치환 &amp; -> &
                  setItemName(book.i_name);
                  setItemPrice(book.i_price); // 사이드바 가격
                  setItemTotalPrice(book.i_price);
                  // setItemPriceMain(Number(mainPrice)); // 스테이트 메인 가격

                  setSaleCard(false);
                  setSaleCash(false);
                  setSaleTransfer(false);
                  setSaleType(false);
                  setSaleMemo('');

                  setShowNumberPad(false);
                  setNumberPadValue(0);

                  window.sessionStorage.setItem('select_copy', book.i_name);
                }}>
                  <td className='p-2.5'>{idx + 1}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.i_brand}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.i_type}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.i_name}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{NumberConvert(book.i_price)} 원</td>
                  <td className={`p-2.5 ${book.i_count_TB < 0 && 'text-red-400 animate-pulse'}`}>{book.i_count_TB === 0 ? '-' : book.i_count_TB}</td>
                  <td className={`p-2.5 ${book.i_count_DS < 0 && 'text-red-400 animate-pulse'}`}>{book.i_count_DS === 0 ? '-' : book.i_count_DS}</td>
                  <td className={`p-2.5 ${book.i_count_JY < 0 && 'text-red-400 animate-pulse'}`}>{book.i_count_JY === 0 ? '-' : book.i_count_JY}</td>
                  <td className={`p-2.5 ${book.i_count_CD < 0 && 'text-red-400 animate-pulse'}`}>{book.i_count_CD === 0 ? '-' : book.i_count_CD}</td>
                </tr>
              ))
              :
              <tr className='relative'>
                <td className='absolute w-full md:top-[30vh] top-[17vh] h-full'>
                  <NotData name={search ? `${search}의 ` : ''}/>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      
      {/* 사이드 */}
      <div className='md:w-1/4 w-full bg-[#424242] md:overflow-y-auto border-[1px] border-gray-500'>
        <div className='bg-[#0067BD] py-2 text-center'>
          <p id='userStore' className='text-left pl-3'>
            {userStore ? `${`※ ${userStore}으로 로그인되었습니다`}` : '정보를 불러올 수 없습니다.'}
          </p>
        </div>
        <div className='p-3 flex flex-col gap-2'>
          
        <div className='w-full'>
          <p>제품 이름</p>
          <input className='bg-[#2E2E2E] mt-2 rounded-t-md w-full h-[70px] text-center font-bold border-b-[1px] hover:border-blue-500 border-gray-400' placeholder='〈 제품을 선택하세요 〉' disabled type='text' value={ItemName}/>
        </div>

        <div id='priceText' className='grid gap-3 w-full'>
          <p className='whitespace-nowrap left-0'>제품 가격</p>
          <input className='bg-[#2E2E2E] border-[1px] border-gray-500 w-full h-[40px] rounded-md text-center' disabled type='text' value={`${NumberConvert(ItemPrice)} 원`} />
        </div>

        <div className='grid gap-3'>
          <p className='whitespace-nowrap'>금액 합계</p>
          <input className='bg-[#2E2E2E] border-[1px] border-gray-500 h-[40px] w-full rounded-md text-center' disabled type='text' value={`${NumberConvert(itemTotalPrice)} 원`} />
        </div>

        <div className='grid gap-3'>
            <p className='whitespace-nowrap'>판매 수량</p>
          <div className='flex justify-center items-center gap-1 w-full'>
            <button className='p-2 bg-[#2E2E2E] border-[1px] border-[#1F8BE2] rounded-sm w-full'
            onClick={ItemCount_Down5}>
              {'《'}
            </button>
            <button className='p-2 bg-[#2E2E2E] border-[1px] border-[#1F8BE2] rounded-sm w-full'
            onClick={ItemCount_Down}>
              {'〈'}
            </button>
            {/* 수량 */}
            <div>
              <p className='bg-[#2E2E2E] py-2.5 rounded-md whitespace-nowrap w-20 text-center'>{`${itemCount} 개`}</p>
            </div>
            <button className='p-2 bg-[#2E2E2E] border-[1px] border-[#1F8BE2] rounded-sm w-full'
            onClick={ItemCount_Up}>
              {'〉'}
            </button>
            <button className='p-2 bg-[#2E2E2E] border-[1px] border-[#1F8BE2] rounded-sm w-full'
            onClick={ItemCount_Up5}>
              {'》'}
            </button>
          </div>
        </div>

        {/* 언더라인 */}
        <div className='border-b-[1px] border-gray-400 py-1 mb-1.5'></div>

        <div className='flex flex-col justify-center items-center gap-3'>

          <div className='grid gap-3 w-full'>
            <p className='whitespace-nowrap'>할인 금액</p>
            <input type='text' disabled id='discountText' value={numberPadValue ? `-${NumberConvert(numberPadValue)} 원` : '0 원'} 
            className={`
            ${numberPadValue && 'bg-blue-500/90 border-none text-base'}
            bg-[#2E2E2E] border-[1px] border-gray-500 w-full h-[40px] rounded-md text-center
            `} style={{fontFamily: 'Gugi'}}/>
          </div>

          {/* 키패드 */}
          <div className='w-full flex flex-col gap-3'>              
            <div className={`${!showNumberPad ? 'inline' : 'hidden'}`}>
              <button className='bg-[#2E2E2E] h-[40px] w-[100%] rounded-md text-center border-[1px] border-[#1F8BE2]' 
              onClick={()=>{
                if(!itemIno || !ItemName) return alert('제품을 먼저 선택해 주세요');
                setNumberPadValue('');
                setItemTotalPrice(ItemPrice * itemCount);
                setShowNumberPad(!showNumberPad);
              }}>
                {showNumberPad ? '키패드 닫기' : '키패드 열기'}
              </button>
            </div>
            <div className={`${showNumberPad ? 'inline' : 'hidden'} grid grid-cols-1 gap-3 border-gray-500 border-2 bg-[#2E2E2E] rounded-md p-3`}>
              <NumberPad numberPadValue={numberPadValue} setNumberPadValue={setNumberPadValue} />
              <div className='grid grid-cols-1 gap-3'>
                <button className='bg-blue-500 p-2 duration-150 rounded-md hover:scale-95 active:bg-[#2E2E2E]' 
                onClick={()=>{                  
                  setItemTotalPrice(itemTotalPrice - numberPadValue);
                  setShowNumberPad(false);
                  console.log('토탈', itemTotalPrice, '할인', numberPadValue);
                }}>
                  적용
                </button>
                {/* <button className='bg-blue-500 p-2 duration-150 rounded-md hover:scale-95 active:bg-[#2E2E2E]' 
                onClick={()=>{
                  // setItemTotalPrice(ItemPrice * itemCount);
                  // setNumberPadValue('');
                  setNumberPadValue('');
                  setItemTotalPrice(ItemPrice);
                  setShowNumberPad(false);
                }}>
                  닫기
                </button> */}
              </div>
            </div>
          </div>

        </div>
        
        {/* 언더라인 */}
        <div className='border-b-[1px] border-gray-400 py-1'></div>

        <div className='mb-[-10px]'>
          <div className='flex justify-between'>
            <p className=''>결제 방식 {'〈 필수사항 〉'}</p>
            <button className='hidden lg:inline px-2 text-yellow-400' 
            onClick={()=>{
              alert('제품 판매시 손님이 결재하신 방식을 선택해 주세요.');
            }}>
            도움말
            </button>
          </div>
          <div className='flex justify-center my-3 items-center'>
            <ul className="grid w-full gap-1 grid-cols-3">
              <li>
                <input type="checkbox" id="card" value="card" className="hidden peer" checked={saleType === '카드' ? true : false} 
                onChange={(e)=>{
                  if(saleCard){
                    setSaleCard(false);
                    setSaleType('');
                  } else {
                    setSaleCard(e.target.checked);
                    setSaleType('카드');
                  }
                  setSaleCash(false);
                  setSaleTransfer(false);
                }} />
                <label htmlFor="card" className="duration-150 inline-flex items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-200 bg-gray-800 hover:bg-gray-700">                           
                  <div className="flex justify-center items-center">
                    <div className="w-full whitespace-nowrap text-base">카드</div>
                  </div>
                </label>
              </li>
              <li>
                <input type="checkbox" id="cash" value="cash" className="hidden peer" 
                checked={saleType === '현금' ? true : false}
                onChange={(e)=>{
                  if(saleCash){
                    setSaleCash(false);
                    setSaleType('');
                  } else {
                    setSaleCash(e.target.checked);
                    setSaleType('현금');
                  }
                  setSaleCard(false);
                  setSaleTransfer(false);
                  }} />
                <label htmlFor="cash" className="duration-150 inline-flex items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-200 bg-gray-800 hover:bg-gray-700">
                  <div className="flex justify-center items-center">
                    <div className="w-full whitespace-nowrap text-base">현금</div>
                  </div>
                </label>
              </li>
              <li>
                <input type="checkbox" id="transfer" value="transfer" className="hidden peer" checked={saleType === '이체' ? true : false} 
                onChange={(e)=>{
                  if(saleTransfer){
                    setSaleTransfer(false);
                    setSaleType('');
                  } else {
                    setSaleTransfer(e.target.checked);
                    setSaleType('이체');
                  }
                  setSaleCash(false);
                  setSaleCash(false);
                  }} />
                <label htmlFor="transfer" className="duration-150 inline-flex items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-200 bg-gray-800 hover:bg-gray-700">
                  <div className="flex justify-center items-center">
                    <div className="w-full whitespace-nowrap text-base">이체</div>
                  </div>
                </label>
              </li>
            </ul>
          </div>
        </div>

        <div className='flex flex-col gap-2 w-full'>
          <div className='flex justify-between'>
            <p className=''>참고사항</p>
            <button className='hidden lg:inline px-2 text-yellow-400' onClick={()=>alert('텍스트박스 우측 하단을 드래그시 창을 늘리거나 축소 할 수 있습니다.')}>
              펼치기
            </button>
          </div>
          <div className='flex flex-col justify-center items-center'>
            <textarea className='h-20 bg-[#2E2E2E] mt-2 focus:border-[#2E2E2E] focus:scale-105 hover:border-gray-500 duration-150 w-full p-2 rounded-md outline-none border-[1px] border-gray-400'
            type='text' placeholder='참고할 부분이 있으면 적어주세요' value={saleMemo} onChange={(e)=>setSaleMemo(e.target.value)} />
          </div>
        </div>

        {/* 언더라인 */}
        <div className='border-b-[1px] border-gray-400 py-1'></div>

        <div className='flex flex-col gap-2 pt-2'>
          <button className='bg-[#2E2E2E] h-[40px] w-[100%] rounded-md text-center border-[1px] border-[#1F8BE2]' 
          onClick={(e)=>ItemSale(e)}>
            판매 등록
          </button>
          <div className='flex justify-center items-center gap-2'>
            <button className='bg-[#2E2E2E] h-[40px] w-full rounded-md text-center border-[1px] border-yellow-300' 
            onClick={(e)=>ItemService(e)}>
              서비스
            </button>
            <button className='bg-[#2E2E2E] h-[40px] w-full rounded-md text-center border-[1px] border-yellow-300' 
            onClick={(e)=>ItemTesting(e)}>
              시연용
            </button>
          </div>
        </div>

        </div>
      </div>

    </section>

  </div>
  )
}

export default Sale